import { Box, useTheme } from "@mui/material";

import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";
import InventoryIcon from '@mui/icons-material/Inventory';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';


export const AMProductExport = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <PopoverModal
            {...props}
        >
            <Box 
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >

                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.exportProducts()
                    }}
                >
                    <ActionIcon>
                        <AllInboxOutlinedIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('export_products')}
                        </Text>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.exportStockModal()
                    }}
                >
                    <ActionIcon>
                        <InventoryIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('export_stock')}
                        </Text>
                    </Box>
                </ActionButton>
               
            </Box>
        </PopoverModal>
    );
}